import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import BackendService from '../services/backendService';
import { Standards } from '../services/backendService/types';

const useStandards = ({ isGenerator }: { isGenerator?: boolean }) => {
  const client = useQueryClient();

  const router = useRouter();
  const { data: standards, isFetching: isFetchingStandards } = useQuery<
    Standards[] | undefined
  >(
    ['standards'],
    async () => {
      return BackendService.instance.standards.fetchAllStandards();
    },
    {
      staleTime: 1000 * 60 * 5,
      retry: 3,
      enabled: Boolean(isGenerator),
    },
  );

  const { mutate: createStandard, isLoading: isCreatingStandard } = useMutation(
    async ({ label, description }: { label: string; description: string }) => {
      if (!label || !description) {
        throw new Error('label and description are required');
      }
      return BackendService.instance.standards.createStandard({ label, description });
    },
    {
      onSettled: () => {
        client.invalidateQueries(['standards']);
      },
    },
  );

  return {
    standards: standards ?? [],
    isFetchingStandards,
    isCreatingStandard,
    createStandard,
  };
};

export default useStandards;
